import React from "react";
import { Gap, Typography } from "../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../style";

const StatutoryLabourWelfareFundDetails = () => {
  return (
    <>
      <Typography variant="h5" mb={"0"}>
        Labour Welfare Information
      </Typography>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            State
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            West Bengal
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            {`Employee's`} Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ₹ 3.00
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            {` Employer's`} Contribution
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            ₹ 15.00
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Deduction Cycle
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Half Yearly
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>
    </>
  );
};

export default StatutoryLabourWelfareFundDetails;
